"use client";
import SeachIcon from "@/assets/icons/search.svg";

interface Props {
  searchTerm: string;
  setSearchTerm: (value: string) => void;
}

const SearchInput = ({ searchTerm, setSearchTerm }: Props) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchTerm(value || "");
  };

  return (
    <div className="w-[300px] md:w-[350px]">
      <div className="flex items-center border-endemicGray-300 border-2 rounded-full gap-x-2">
        <SeachIcon className="w-5 h-5 fill-primary ml-5 mr-1 endemic:fill-secondary" />
        <input
          type="text"
          value={searchTerm}
          onChange={handleChange}
          placeholder="Search..."
          className="h-14 rounded-3xl outline-none bg-transparent w-full"
        />
      </div>
    </div>
  );
};

export default SearchInput;
